export const TENANT_CONFIG = {
  qmee: {
    name: 'Qmee',
    homeUrl: 'https://qmee.prod.qurated.ai',
    description: 'Earn real cash when you search, shop & take surveys',
    facebookAppId: '123775991104422', // Qmee's Facebook App ID
  },
  mobiworkx: {
    name: 'MobiWorkX',
    homeUrl: 'https://mobiworkx.prod.qurated.ai',
    description: 'Earn rewards when you shop online and complete surveys',
    facebookAppId: '123775991104422', // Using Qmee's for now - to be updated later
  },
  lifepoints: {
    name: 'LifePoints',
    homeUrl: 'https://lifepoints.prod.qurated.ai',
    description: 'Earn points when you shop online and share your opinions',
    facebookAppId: '123775991104422', // Using Qmee's for now - to be updated later
  },
} as const;

export type Tenant = keyof typeof TENANT_CONFIG;
export type TenantConfig = (typeof TENANT_CONFIG)[Tenant];

export const getTenantConfig = (tenant: string): TenantConfig => {
  return TENANT_CONFIG[tenant as Tenant] || TENANT_CONFIG.qmee;
};

export const getDefaults = (currentTenant: TenantConfig) => ({
  surveyComplete: { amount: 'cash out', url: currentTenant.homeUrl },
  offer: {
    title: '',
    url: currentTenant.homeUrl,
    paysReward: true,
    rewardLabel: '',
    advertiser: { name: currentTenant.name },
  },
  shareInfo: {
    title: `Check Out ${currentTenant.name}`,
    description: currentTenant.description,
    url: currentTenant.homeUrl,
    imageUrl: 'oinq.png',
    ref: currentTenant.homeUrl,
  },
  balance: 'cash',
});

export const balanceDescriptionGenerator = (accountName: string, balance: string) =>
  `I've earned ${balance} with ${accountName}! You can too - join ${accountName} to get cash rewards when shopping online and answering surveys`;

export const offerDescriptionGenerator = (accountName: string, offerData: any) =>
  offerData.paysReward
    ? `Check out this ${accountName} cashback offer! You can earn ${offerData.rewardLabel} cashback when you take part in this offer from ${offerData.advertiser.name} - have a look at the full offer here.`
    : `Check out this ${accountName} deal for ${offerData.advertiser.name}! ${offerData.title} Have a look at the full deal here.`;

export const surveyCompleteDescriptionGenerator = (amount: string) =>
  `I've just earned another ${amount} by sharing my opinion & completing a survey!`;

export const generateFacebookShareUrl = (url: string, appId: string): string => {
  return `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=${encodeURIComponent(
    url,
  )}&redirect_uri=${encodeURIComponent(url)}`;
};

export interface ShareContent {
  title: string;
  description: string;
  url: string;
}

export const generateShareContent = (
  type: 'offer' | 'balance' | 'surveyComplete' | 'noTemplate',
  currentTenant: TenantConfig,
  defaults: ReturnType<typeof getDefaults>,
  offer?: any,
  balance?: string,
  surveyComplete?: { amount: string },
  shareInfo?: any,
): ShareContent => {
  switch (type) {
    case 'balance':
      return {
        title: `I've earned ${balance} with ${currentTenant.name}!`,
        description: balanceDescriptionGenerator(currentTenant.name, balance || defaults.balance),
        url: currentTenant.homeUrl,
      };
    case 'offer':
      return {
        title: `Check out this ${currentTenant.name} cashback Offer!`,
        description: offerDescriptionGenerator(currentTenant.name, offer || defaults.offer),
        url: offer ? offer.url : defaults.offer.url,
      };
    case 'surveyComplete':
      return {
        title: `I just completed another survey on ${currentTenant.name}!`,
        description: surveyCompleteDescriptionGenerator(
          surveyComplete ? surveyComplete.amount : defaults.surveyComplete.amount,
        ),
        url: currentTenant.homeUrl,
      };
    default:
      return {
        title: shareInfo?.title || defaults.shareInfo.title,
        description: shareInfo ? shareInfo.description : defaults.shareInfo.description,
        url: shareInfo ? shareInfo.url : defaults.shareInfo.url,
      };
  }
};
